import { useState, useEffect } from "react";
import Loader from "../../common/loader";
import NavBar from "../../common/navbar";
import { handleAuth, postRequestOptions, getRequestOptions, baseUrl } from "../../common/cookie";
import axios from "axios";


function CheckMUFG() {
  
  let [error, setError] = useState<any>(null);

  let url: any = baseUrl + `previous-collections`;
  let [dates, setCollectionDates]: any = useState([]);
  useEffect(() => {
    fetch(url, getRequestOptions)
      .then((res) => {
        handleAuth(res.status);
        return res.json();
      })
      .then((data) => {
        setCollectionDates(data);
      });
  }, []);

  async function handleSubmit(event: any) {
    event.preventDefault();
    setRequestStatus(true);

    // handle file processing here
    const form: any = document.getElementById("check-mufg");
    const formData = new FormData(form);
    try {
      setError(null);
      let url = baseUrl + "check-mufg";
      let action: any = await axios.post(url, formData, postRequestOptions);
      handleAuth(action);
      if (action.data.error) {
        setError(action.data.error);

        setRequestStatus(false);
      } else {
        setRequestStatus(false);
        window.open(action.data);
      }
    } catch (error) {
      console.error("Error:", error);

      setRequestStatus(false);
    }
  }

  const [request, setRequestStatus] = useState(false);

  if (request) {
    return (
      <div>
        <NavBar />
        <Loader />
      </div>
    );
  }
  return (
    <div>
      <NavBar />
      <div className="title">
        <h1>Check MUFG Notional Amount, Average Cost, Prices</h1>
      </div>
      <div className="card-body card row xlsx-card">
        <form onSubmit={(event) => handleSubmit(event)} encType="multipart/form-data" id="check-mufg">
          <div>
            <h3>Select a collection date</h3>
          </div>
          <select className="select-collection-date" name="collectionDate">
            {dates.map((date: any, index: any) => (
              <option key={index} value={date}>
                {date}
              </option>
            ))}
          </select>

          <div>
            <h3>Input MUFG File csv/xlsx file</h3>
          </div>

          <div className="drop-container">
            <input multiple={true} className="drop-box-input" placeholder="Upload or drop file" type="file" name="mufg" accept=".xlsx, .csv" required />
          </div>

          <button type="submit" className="btn upload-btn">
            Upload
          </button>
        </form>
      </div>
      <h4 className="error-text">{error}</h4>
    </div>
  );
}

export default CheckMUFG;
